<!-- 团长分销页面 -->
<template>
  <div class="colonelDistribution">
    <div class="head-area clr">
      <div class="fl clr left-search">
        <div class="fl search-item">
          <div class="fl head-label-area">用户ID</div>
          <Input class="fl" v-model="id" placeholder="请输入用户ID" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">用户昵称</div>
          <Input class="fl" v-model="nickName" placeholder="请输入用户昵称" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">推荐人昵称</div>
          <Input
            class="fl"
            v-model="parentName"
            placeholder="请输入用户昵称"
            clearable
            style="width:200px"
          ></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">加入时间</div>
          <DatePicker
            v-model="registerTime"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="请选择时间"
            style="width: 200px"
          ></DatePicker>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">手机号</div>
          <Input
            class="fl"
            v-model="mobile"
            placeholder="请输入用户昵称"
            clearable
            style="width:200px"
          ></Input>
        </div>
        <!-- <div class="fl search-item">
          <div class="fl head-label-area">分销状态</div>
          <Select v-model="status" clearable style="width:200px">
            <Option value="1">正常</Option>
            <Option value="2">冻结</Option>
          </Select>
        </div> -->
        <div class="fl search-item" style="margin-left:20px;">
          <Button type="primary" @click="exportData">导出</Button>
          <Button type="primary" @click="showExportList" style="margin-left:10px;">查看导出列表</Button>
        </div>
      </div>
      <div class="fr right-search-btn">
        <Button type="primary" style="margin:0 0 10px;" icon="ios-search" @click="search">查询</Button>
        <Button @click="reset" icon="ios-refresh">重置</Button>
      </div>
    </div>
    <div class="table-area">
      <Table :columns="columns" :data="dataList" :height="tableHeight">
        <template #avatar="{ row }">
          <img style="width:36px;height:36px;margin-top:5px" :src="row.avatar" alt />
        </template>
        <template #action="{ row }">
          <a @click="checkDetial(row)">查看</a>
          <!-- <a style="margin-left:5px" @click="checkDetial(row)">冻结</a> -->
          <!-- <a style="color:red;margin-left:5px" @click="delRow(row)">删除</a> -->
        </template>
      </Table>
    </div>
    <div class="page-area" v-if="dataList.length">
      <Page
        :total="total"
        :current="current"
        show-total
        :page-size="size"
        @on-change="pageChage"
        @on-page-size-change="pageSizeChage"
      ></Page>
    </div>
    <div class="detial-page-area" v-if="modelShow">
      <detialPage
        v-if="modelShow"
        :currentData="currentData"
        @close="modelShow = false"
        @editSuccess="findPageDataList()"
      />
    </div>
    <Modal v-model="exportListModal" title="导出列表" width="600">
      <Table :columns="exportListColumns" :data="exportListData" :height="400">
        <template slot-scope="{ row }" slot="status">
            <div v-if="row.status == 'EXPORTING'">导出中</div> 
            <div v-if="row.status == 'SUCCESS'">成功</div> 
            <div v-if="row.status == 'FAILED'">失败</div> 
        </template>
        <template slot-scope="{ row }" slot="exportAction">
          <a v-if="row.status == 'SUCCESS'" @click="downloadExport(row)">下载</a>
        </template>
      </Table>
      <!-- <div class="page-area" v-if="exportListData.length" style="margin-top: 20px;">
        <Page
          :total="exportListTotal"
          :current="exportListCurrent"
          :page-size="exportListSize"
          :page-size-opts="[20, 50, 100, 500, 1000]"
          show-total
          show-sizer
          @on-change="exportListPageChange"
          @on-page-size-change="exportListPageSizeChange"
        ></Page>
      </div> -->
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { getColonelBrokerageList, exportOrderList, exportRecordList, downloadExportFile } from '@/api/colonelDistribution.js'
import detialPage from './components/detialPage.vue'

export default {
  components: {
    detialPage
  },
  data() {
    return {
      modelShow: false,
      id: '',
      nickName: '',
      parentName: '',
      registerTime: [],
      status:'',
      mobile: '',
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      searchText: '',
      tableHeight: window.innerHeight - 310,
      total: 0,
      current: 1,
      size: 20,
      columns: [
         {
          title: 'id',
          key: 'userId',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '头像',
          key: 'avatar',
          slot: 'avatar',
          width: 120
        },
        {
          title: '用户昵称',
          key: 'nickname',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '推荐人昵称',
          key: 'parentName',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '手机号',
          key: 'mobile',
        },
        {
          title: '加入时间',
          key: 'registerTime',
        },
         {
          title: '团队人数',
          key: 'teamCount',
          width: 120
        },
        {
          title: '累计收益',
          key: 'totalEarnings',
          width: 120
        },
        {
          title: '操作',
          slot: 'action',
          width: 120
        }
      ],
      dataList: [
      ],
      currentData: {},
      // 导出列表相关数据
      exportListModal: false,
      exportListColumns: [
        {
          title: '时间',
          key: 'createTime'
        },
        {
          title: '导出状态',
          slot: 'status',
        },
        {
          title: '操作',
          slot: 'exportAction',
          width: 150
        }
      ],
      exportListData: [],
      exportListTotal: 0,
      exportListCurrent: 1,
      exportListSize: 20
    };
  },
  created() {
    this.findPageDataList()
  },
  methods: {
    reset() {
      this.id = ''
      this.nickName = ''
      this.parentName = ''
      this.registerTime = []
      this.status = ''
      this.current = 1
      this.mobile = ''
      this.findPageDataList()
    },
    search() {
      this.current = 1
      this.findPageDataList()
    },
    exportData() {
      // 收集当前搜索条件
      let params = {}
      if(this.id){
        params.id = this.id
      }
      if(this.nickName){
        params.nickName = this.nickName
      }
      if(this.parentName){
        params.parentName = this.parentName
      }
      if(this.mobile){
        params.mobile = this.mobile
      }
      if (this.registerTime[0] || this.registerTime[1]) {
        params.startDate = this.registerTime[0]
        params.endDate = this.registerTime[1]
      }
      
      // 调用导出接口
      exportOrderList(params).then(res => {
        if (res.success) {
          this.$Message.info('正在执行导出操作，请稍后查看导出列表');
        } else {
          this.$Message.error(res.message || '导出失败');
        }
      }).catch(error => {
        this.$Message.error('导出失败：' + (error.message || '未知错误'));
      });
    },
    showExportList() {
      this.exportListModal = true;
      // 获取导出列表数据
      exportRecordList().then(res => {
        if (res.success) {
          this.exportListData = res.result
          this.exportListModal = true;
        }
      }).catch(error => {
        this.$Message.error('获取导出列表失败：' + (error.message || '未知错误'));
      });
    },
    downloadExport(row) {
      // 使用API接口方式下载文件
      downloadExportFile({id: row.id}).then(res => {
        // 直接处理返回的blob数据
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '团长分销_' + row.createTime + '.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
        this.$Message.success('下载成功');
      }).catch(error => {
        this.$Message.error('下载失败：' + (error.message || '未知错误'));
      });
    },
    exportListPageChange(page) {
      this.exportListCurrent = page;
      // 这里应该重新加载数据
    },
    exportListPageSizeChange(size) {
      this.exportListSize = size;
      this.exportListCurrent = 1;
      // 这里应该重新加载数据
    },
    findPageDataList() {
      let params = { pageIndex: this.current, size: this.size }
      params.id = this.id
      params.nickName = this.nickName
      params.parentName = this.parentName
      params.mobile = this.mobile
      // params.status = this.status
      if (this.registerTime[0] || this.registerTime[1]) {
        params.startDate = this.registerTime[0]
        params.endDate = this.registerTime[1]
      }
      getColonelBrokerageList(params).then(res => {
        console.log(res)
        if (res.success) {
          this.dataList = res.result.list
          this.total = res.result.total
        }
      })
    },
    checkDetial(row) {
      this.modelShow = true
      this.currentData = JSON.parse(JSON.stringify(row))
    },
    delRow(row) {
      this.$Modal.confirm({
        title: "确认删除？",
        onOk: () => {
          // deleteMember({ id: row.id }).then(res => {
          //   if (res.success) {
          console.log(row)
          this.$Message.success('删除成功！')
          this.findPageDataList()
          //   }
          // })
        },
      })
    },
    pageChage(page) {
      this.current = page
      this.findPageDataList()
    },
    pageSizeChage(size) {
      this.size = size
      this.findPageDataList()
    },
  }
}

</script>
<style lang='scss' scoped>
.colonelDistribution {
  .left-search {
    width: 900px;
    .search-item {
      margin-bottom: 10px;
    }
  }
  .right-search-btn {
    width: 100px;
    border-left: 1px solid #e5e6eb;
    padding-left: 20px;
  }
  .head-label-area {
    line-height: 36px;
    width: 90px;
    padding-right: 15px;
    text-align: right;
  }
  .detial-page-area {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // padding: 20px;
    background: #f5f7f9;
    z-index: 100;
    overflow: auto;
  }
}
</style>